// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__jQVxm","appList":"NavBar_appList__+yhKG","userPanel":"NavBar_userPanel__VZ9kt"};